import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { salesQuotes } from "../../../../../../redux/sales-quotes/action";
import { selectSalesQuotesListItems } from "../../../../../../redux/sales-quotes/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../redux/library/selector";

const SalesQuotesContainer = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectSalesQuotesListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'SalesQuoteNumber', headerName: 'SalesQuote Number', searchField: 'SalesQuoteNumber', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'SalesQuoteStatusId',
        headerName: 'Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.SalesQuoteStatus },
        sortable: true,
        filter: true
      },
      { field: 'TotalItemCount', headerName: 'Item Count' },
      { field: 'DiscountAmount', headerName: 'Discount Amount', isCurrencyValueFormat: true },
      { field: 'TaxAmount', headerName: 'Tax Amount', isCurrencyValueFormat: true },
      { field: 'TotalAmount', headerName: 'Total Amount', isCurrencyValueFormat: true },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true, sortable: false }
    ]);
  }

  

  const fetchSalesQuotes = ()=>{
    dispatch(salesQuotes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/sales-quotes/list`,
      entity: 'salesQuotes',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
 
  useEffect(() => {
    createColumnDefs()
    fetchSalesQuotes()
  }, [pageData,pageSize])

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleDelete = (data: any) => {
    dispatch(salesQuotes.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/sales-quotes/delete`,
      entity: 'salesQuotes',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchSalesQuotes()
     
    });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchSalesQuotes()
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add SalesQuotes</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "SalesQuoteNumber",
        FieldText: "SalesQuoteNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(salesQuotes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/sales-quotes/list`,
      entity: 'salesQuotes',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }
  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
      enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Sales Quotes" />
      }
    </>

  );
};

export default SalesQuotesContainer;


